module.exports = __webpack_public_path__ + "img/bg.1f2012a8.png";